import { Grid } from '@mui/material';
import React from 'react';
import { ThemeProvider } from '../../styles/theme-config/ThemeProvider';
import UtteranceTiles from './UtteranceTiles';

/**
 * @name UtteranceTilesContainer
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders Utterance Tiles Container component
 */
const UtteranceTilesContainer = props => (
  <>
    <ThemeProvider palette={props?.cmsData?.Utterance_theme?.theme}>
      <Grid container>
        <UtteranceTiles
          cmsData={props?.cmsData}
          showLoginVerificationModal={props?.showLoginVerificationModal}
          sweeprParams={props?.sweeprParams}
          setSweeprParams={props?.setSweeprParams}
        />
      </Grid>
    </ThemeProvider>
  </>
);

UtteranceTilesContainer.displayName = 'UtteranceTilesContainer';
export default UtteranceTilesContainer;
